import { render, staticRenderFns } from "./DiscountReport.vue?vue&type=template&id=facacc8e&"
import script from "./DiscountReport.vue?vue&type=script&lang=js&"
export * from "./DiscountReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports